import { useState } from "react";
import { GetCrecaAccountsResponseModel } from "@/features/accounts/creca/services/get-accounts-model";


export const useGetCrecaAccountStates = () => {
  const [crecaAccountId, setCrecaAccountId] = useState("");
  const [crecaAccounts, setCrecaAccounts] = useState<GetCrecaAccountsResponseModel[]>([]);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    crecaAccountId,
    crecaAccounts,
    setCrecaAccountId,
    setCrecaAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
